import BaseViewModel from "../../Core/BaseViewModel";
import SectionModel from "../../Models/SectionModel";
import ProductModel from "../../Models/ProductModel";

export default class DealsViewModel extends BaseViewModel{
	loading: boolean = false;
	section: any = SectionModel;
	products: ProductModel[] = [];
}